export default __webpack_public_path__ + "static/media/masteratarms.2d36b905.png";